import { BACKEND_URL } from './urlsRequests';

export const signURL = `${BACKEND_URL}/signin`;
export const createURL = `${BACKEND_URL}/users`;
